export class GqlObject {
  constructor(value, mapper) {
    this.value = value;
    this.mapper = mapper;
  }
}
